module.exports = __webpack_public_path__ + "img/img_zhaopian@2x.6087f329.png";